import React from 'react'

export default () => (
  <div style={{ textAlign: 'center' }}>
    <h1 style={{ fontSize: '20px', color: 'white', margin: '150px 20px' }}>ขออภัยด้วยครับ หวยนี้ปิดรับแล้วนะครับ</h1>
  </div>
)
